module.exports = __webpack_public_path__ + "static/Tritech-23f7dfbc67b6f58d93f7cd422e5604a3.webp";